const state = {
  token: '',
  name: '管理员',
  avatar: '',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  setUserInfo({ commit }, userInfo) {
    const { name, avatar, roles } = userInfo
    commit('SET_NAME', name)
    commit('SET_AVATAR', avatar)
    commit('SET_ROLES', roles)
  },
  resetToken({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
